module.exports = __webpack_public_path__ + "img/pic2.a7a43290.png";